import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { uiActions } from "../../store";

export default function ChamUpload() {
    const dispatch = useDispatch();

    useEffect(() => {
        document.querySelector("im-upload").addEventListener("upload", function () {
            if(document.getElementById("imgInp").value !== ""){
                document.querySelector("dialog").showModal();
            } 
          });
          
          document.getElementById('imgToUpload').addEventListener('load', function(){ // Goes straight to visualizer
            dispatch(uiActions.setVizLoading(true));
            document.querySelector('#upload-section .btn-upload').click();
          });
    

    }, []);

    return(
        <im-upload title="Upload My Own Photo" calltoaction="Start Your Project" active="0" postpage="IM.aspx"></im-upload>
    );
}

export function ChamUploadButton({className, title}) {

    const handleClick = function() {
        document.querySelector(".uploaderBTN").click()
    }

    return(
        <button onClick={handleClick} className={className}>{title}</button>
    )
}